import { useQuery } from '@tanstack/react-query';

import { getFaqs } from '@/services/faqs';

type FaqEntityType = 'CLASS' | 'CLASS_PACK' | 'SUBSCRIPTION' | 'GIFT_CARD';

interface UseFaqsParams {
  entityType: FaqEntityType;
  entityId?: string;
  slug?: string;
  enabled?: boolean;
}

export default function useFaqs({
  entityType,
  entityId,
  slug,
  enabled = true,
}: UseFaqsParams) {
  const { data, isLoading } = useQuery({
    queryKey: ['faqs', entityType, entityId ?? slug ?? 'global'],
    queryFn: () =>
      getFaqs({
        entity_type: entityType,
        entity_id: entityId,
        slug,
      }),
    enabled,
  });

  return {
    data: data ?? [],
    isLoading,
  };
}
